// react-native-image-picker v7+ returns { didCancel, errorCode, assets: [{ uri, fileName, ... }] }
// whereas callers written against v3 expect a FLAT response
// { didCancel, uri, fileName, type, ... }. This shim wraps v7's
// launchCamera / launchImageLibrary so those older callers keep working
// unchanged — replace their import path with @utils/imagePickerCompat.
//
// New code should use v7's native promise API directly.

import {
  launchCamera as rnLaunchCamera,
  launchImageLibrary as rnLaunchImageLibrary,
} from "react-native-image-picker";

const flatten = (r) => {
  if (!r) return { didCancel: true };
  if (r.didCancel) return { didCancel: true };
  if (r.errorCode) {
    return {
      didCancel: false,
      error: r.errorMessage || r.errorCode,
    };
  }
  const a = r.assets && r.assets[0];
  if (!a) return { didCancel: true };
  return {
    didCancel: false,
    uri: a.uri,
    fileName: a.fileName,
    type: a.type,
    fileSize: a.fileSize,
    width: a.width,
    height: a.height,
    duration: a.duration,
    base64: a.base64,
  };
};

const wrap = (fn) => (options, callback) => {
  if (typeof callback === "function") {
    fn(options, (r) => callback(flatten(r)));
    return undefined;
  }
  return fn(options).then(flatten);
};

export const launchCamera = wrap(rnLaunchCamera);
export const launchImageLibrary = wrap(rnLaunchImageLibrary);
